function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "14",
  viewBox: "0 0 19 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.769 10.202H3.682V8.047h12.087c.59 0 1.068-.477 1.068-1.063 0-.587-.48-1.063-1.068-1.063-.589 0-1.067.477-1.067 1.063h-2.164a3.229 3.229 0 013.231-3.218 3.229 3.229 0 013.232 3.218 3.23 3.23 0 01-3.232 3.218z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.052 6.937H0V4.782h9.052c.589 0 1.067-.477 1.067-1.063a1.067 1.067 0 00-2.135 0H5.82A3.229 3.229 0 019.052.5a3.229 3.229 0 013.231 3.218 3.229 3.229 0 01-3.231 3.219z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.289 11.345H1.418V13.5h10.87v-2.155z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h19v13H0z"
})))));